var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.62312 17.6641C1.02686 18.3112 1.72749 18.7031 2.49344 18.7031H16.5059C17.2719 18.7031 17.9725 18.3112 18.3763 17.6641C18.774 17.0109 18.8097 16.2094 18.4713 15.5266L11.459 1.50811C11.085 0.765927 10.3369 0.296875 9.49971 0.296875C8.66254 0.296875 7.91437 0.765927 7.54032 1.50812L0.528132 15.5266C0.189694 16.2153 0.225314 17.0109 0.62312 17.6641ZM10.3903 6.21061V11.8691C10.3903 12.3619 9.99254 12.7597 9.49971 12.7597C9.00687 12.7597 8.60903 12.3619 8.60903 11.8691V6.21061C8.60903 5.71781 9.00687 5.31998 9.49971 5.31998C9.99254 5.31998 10.3903 5.71781 10.3903 6.21061ZM8.60903 15.1168V14.4697C8.60903 13.9769 9.00687 13.5791 9.49971 13.5791C9.99254 13.5791 10.3903 13.9769 10.3903 14.4697V15.1168C10.3903 15.6037 9.99254 16.0075 9.49971 16.0075C9.00687 16.0075 8.60903 15.6037 8.60903 15.1168Z",
    fill: "#EB6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalError);
export default __webpack_public_path__ + "static/media/CriticalError.2aeaf41de30b84b5b9382c3ca5c1d805.svg";
export { ForwardRef as ReactComponent };